import React from 'react';
import { ContentHolderWrapper } from './styles/contentHolder.style';

export default props => (
  <ContentHolderWrapper className="isoExampleWrapper">
    {props.children}
  </ContentHolderWrapper>
);


// WEBPACK FOOTER //
// ./src/components/UI/ContentHolder.js